<template>
  <app-table
    ref="app_table_ref"
    :table-key="table_key"
    :tablep="table_params"
    :get-data="getStarTasksList"
    :table-props="{ 'max-height': '450px'}"
    :check="true"
    check-key="id"
    :is-reserve-checked="true"
    :is-row-click="true"
    @select-tr="selectionChange"
    @hook:mounted="onTableMounted"
  />
</template>

<script>
import { data_sharing_mixin } from '@/views/fusion/investment/intelligence-create/mixins/data-sharing';
import { getStarDeliveryTaskListApi } from '@/api/tool/star-delivery';

export default {
  components: {
    'app-table': () => import('@/components/app-table'),
  },
  mixins: [data_sharing_mixin],
  props: {
    /** 表单项配置 */
    formItem: {
      type: Object,
      required: true,
    },
    /** 广告主ID */
    advertiserId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      /** 表头配置 */
      table_key: require('./model/table-key.js')(this),
      /** 表格请求参数 */
      table_params: {
        page: 1,
        page_size: 10,
      },
    };
  },
  methods: {
    /**
     * 获取初始化配置
     * @returns {Object}
     */
    getInitConfig() {
      try {
        const { getFormContext } = this.local_sharing_data;
        const form_context = getFormContext();
        const { init_ops } = form_context.config;
        return init_ops || {};
      } catch (error){
        console.error(error);
        return {};
      }
    },
    /**
     * 获取获取星广联投任务列表页列表
     * @param {Object} params 接口参数
     * @returns {Promise<Object>}
     */
    getStarTasksList(params) {
      const { channel_interface } = this.getInitConfig();
      return new Promise((resolve, reject) => {
        getStarDeliveryTaskListApi({
          channel_interface,
          advertiser_id: this.advertiserId,
          ...params,
        }).then(res => {
          res.list = (res?.list || []).map(item => Object.assign(item, { advertiser_id: this.advertiserId }));
          resolve({ ...res });
        }).catch(reject);
      });
    },
    /**
     * 监听表格挂载完成
     * @returns {void}
     */
    onTableMounted() {
      this.initRowsSelection();
    },
    /**
     * 初始化表格选中数据
     * @returns {void}
     */
    initRowsSelection() {
      const app_table_ref = this.$refs.app_table_ref;
      const assign_selection = this.formItem.assignSelection[this.advertiserId] || [];
      app_table_ref.multipleSelection.splice(0);
      app_table_ref.multipleSelection.push(...assign_selection);
      app_table_ref.multipleSelectionAll.splice(0);
      app_table_ref.multipleSelectionAll.push(...assign_selection);
    },
    /**
     * 表格选择事件
     * @param {object} rows 表格数据
     */
    selectionChange(rows) {
      if (rows?.length > 1) {
        this.$message.warning('仅允许选中1条数据');
        this.resetTableSelection();
        return;
      }

      if (!this.formItem.assignSelection[this.advertiserId]) {
        this.formItem.assignSelection[this.advertiserId] = [];
      }
      const assign_selection = this.formItem.assignSelection[this.advertiserId];
      assign_selection.splice(0);
      assign_selection.push(...rows);
    },
    /**
     * 重置表格选中
     * @returns {void}
     */
    resetTableSelection() {
      const app_table_ref = this.$refs.app_table_ref;
      const assign_selection = this.formItem.assignSelection[this.advertiserId] || [];

      app_table_ref?.$refs?.table?.clearSelection?.();

      app_table_ref?.multipleSelection?.splice(0);
      app_table_ref?.multipleSelection?.push(...assign_selection);
      app_table_ref?.multipleSelectionAll?.splice(0);
      app_table_ref?.multipleSelectionAll?.push(...assign_selection);

      app_table_ref?.selectedPreExisting?.(assign_selection);
    },
  },
};
</script>
